<template>
  <div>
    <b-sidebar
      id="sidebar-backdrop"
      backdrop
      :width="$device.isMobile ? '320px' : '344px'"
      bg-variant="bgcontainer"
      body-class="scroll-bar"
      no-header
      :visible="visible"
      @change="visibleChange"
    >
      <template v-if="$device.isMobile" #default>
        <div
          class="header d-flex align-items-center justify-content-between px-3 pt-3"
        >
          <i
            class="icon-Circle-X text-32 text-primary cursor-pointer"
            @click="onClickClose"
          ></i>
        </div>
        <div class="content mt-1">
          <div class="bg-white p-3 mt-3">
            <div v-for="list in mobileList" :key="list.key" class="list">
              <div v-if="list.title" class="title text-14">
                {{ list.title }}
              </div>
              <template v-for="item in list.group">
                <div
                  v-if="!item.isHidden"
                  :key="item.key"
                  class="list-item d-flex align-items-center bg-white position-relative"
                  @click="onClickEvent(item)"
                >
                  <img
                    v-if="item?.img"
                    width="32"
                    class="d-block img-fluid mr-2"
                    :src="item.img"
                    :alt="item.title"
                  />
                  <i
                    v-else
                    :class="`icon-${item.icon} ${
                      item.variant ? 'text-' + item.variant : 'text-dark'
                    }`"
                    class="text-32 mr-2"
                  ></i>
                  {{ item.title }}
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
      <template v-else #default>
        <div class="header position-relative">
          <i
            class="icon-Circle-X text-40 text-primary cursor-pointer position-absolute"
            @click="onClickClose"
          ></i>
        </div>
        <div class="sidebar-content">
          <div class="text-18 font-weight-bold mb-5">
            <div
              v-for="tab in primaryLinks"
              :key="tab.key"
              class="button p-4 d-flex align-items-center cursor-pointer shadow-sm position-relative"
              :class="{active: isActive(tab)}"
              @click="onClickEvent(tab)"
            >
              <img
                v-if="tab?.img"
                width="32"
                :src="tab.img"
                class="mr-4 img-fluid"
                :alt="tab.title"
              />
              <i
                v-if="tab?.icon"
                :class="`icon-${tab.icon}`"
                class="text-32 text-primary mr-4"
              ></i>
              {{ tab.title }}
            </div>
          </div>

          <h4
            v-show="secondaryLinks.length"
            class="font-weight-bold text-18 mb-2"
          >
            {{ $t('其他') }}
          </h4>
          <template v-for="link in secondaryLinks">
            <a
              v-if="!link.isHidden"
              :key="link.key"
              :href="link.href"
              class="link d-flex align-items-center justify-content-between px-4 d-block w-100 shadow-sm cursor-pointer"
              :class="link.items ? 'mb-1' : 'mb-3'"
              target="_blank"
              @click="onClickEvent(link)"
            >
              <div class="d-flex align-items-center">
                <i class="text-32 mr-4" :class="`icon-${link.icon}`"></i>
                {{ link.title }}
              </div>

              <i
                v-if="link?.items"
                class="text-32 text-primary"
                :class="link.visible ? 'icon-Chevron-up' : 'icon-Chevron-down'"
              ></i>
            </a>
            <b-collapse
              v-if="!link.isHidden && link?.items"
              :key="`${link.key}-collapse`"
              v-model="link.visible"
              class="mb-3"
            >
              <a
                v-for="(item, i) in link.items"
                :key="item.key"
                :href="item.href"
                class="link d-flex align-items-center pl-7 d-block w-100 shadow-sm cursor-pointer"
                :class="i === link.items.length - 1 ? 'mb-0' : 'mb-1'"
                target="_blank"
                @click="onClickEvent(item)"
              >
                {{ item.title }}
              </a>
            </b-collapse>
          </template>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {Browser} from '@capacitor/browser';
import BackEvent from '@/lib/base/backEvent.js';

export default {
  data() {
    return {
      togglePlanVisible: false,
    };
  },
  computed: {
    visible() {
      return this.$store.state.env.isSidebarShow;
    },
    active() {
      return this.$route.matched[0]?.name;
    },
    primaryLinks() {
      return [
        {
          key: 'kifus',
          icon: 'Kifu',
          title: this.$t('我的棋谱'),
          event: 'kifus',
        },
        {
          key: 'certificates',
          icon: 'Certificate',
          title: this.$t('模拟检定证书'),
          event: 'certificates',
        },
      ];
    },
    secondaryLinks() {
      return [];
    },
    mobileList() {
      return [
        {
          key: 'primary',
          group: this.primaryLinks,
        },
      ];
    },
    allStudents() {
      return this.$store.getters['teacherManagement/allStudents'];
    },
  },
  methods: {
    isActive(tab) {
      if (
        this.$device.isMobile ||
        ['kifus', 'learning-process', 'nfts', 'personal'].includes(tab.event)
      ) {
        return this.active === tab.event;
      } else {
        return (
          this.$route.path.includes(tab.event) || this.active === tab.event
        );
      }
    },
    async onClickEvent(tab) {
      if (tab.href) {
        return Browser.open({
          url: tab.href,
          presentationStyle: 'popover',
        });
      }
      this.closeSidebar();
      return this.$router.push({name: tab.event});
    },
    closeSidebar() {
      this.$store.commit('env/setIsSidebarShow', false);
    },
    visibleChange(visible) {
      this.$store.commit('env/setIsSidebarShow', visible);
      this.togglePlanVisible = false;
      if (!visible) {
        BackEvent.popEvent();
      }
    },
    onClickClose() {
      this.$store.commit('env/setIsSidebarShow', false);
      this.togglePlanVisible = false;
      BackEvent.popEvent();
    },
  },
};
</script>

<style lang="scss" scoped>
:deep() .b-sidebar-backdrop {
  background: $grayscale-50 !important;
}
:deep() .b-sidebar {
  padding: env(safe-area-inset-top) 0 env(safe-area-inset-bottom) 0;
}
:deep() .b-sidebar-body {
  overflow: overlay;
}
:deep().collapse {
  margin-top: -$spacing-xxs;
  display: block !important;
  height: 0;
  overflow: hidden;
  &.show {
    margin-top: 0;
    height: auto;
  }
  &.collapsing {
    margin-top: 0;
  }
}

#sidebar-backdrop {
  .sidebar-content {
    margin-top: 4px;
  }

  .list {
    &:not(:first-child) {
      margin-top: 24px;
    }
  }
  .title {
    padding: 0 20px;
    color: $font-grayscale-2;
    margin-bottom: 8px;
    line-height: 30px;
    background: $grayscale-5;
    border-radius: 3px;
  }
  .list-item {
    padding: 9px 0px;
    &:not(:last-child) {
      border-bottom: 1px solid $line-2;
    }
  }
  .notification {
    width: 14px;
    height: 14px;
    top: 9px;
    left: 20px;
    border-radius: 50%;
  }
}

@media screen and (min-width: 768px) {
  :deep() .b-sidebar {
    left: 116px;
    &:not(.b-sidebar-right) {
      left: 116px;
    }
  }
  #sidebar-backdrop {
    .icon-Circle-X {
      top: 16px;
      right: 16px;
    }
    .sidebar-content {
      margin-top: 0;
      padding: 72px 24px;
    }
    h4 {
      color: $font-grayscale-2;
    }
    .button {
      border-radius: $rounded-md;
      line-height: 30px;
      background: $white;
      transition: all 0.3s;
      &:not(:last-child) {
        margin-bottom: 16px;
      }
      &:hover {
        background: rgba(255, 192, 105, 0.3);
      }
      &.active {
        color: $white;
        background: $secondary;
      }
    }
    .link {
      text-decoration: none;
      color: $font-grayscale-1;
      background: $white;
      border-radius: $rounded-md;
      line-height: 40px;
      &:hover {
        background: rgba(255, 192, 105, 0.3);
      }
    }
    .notification {
      width: 14px;
      height: 14px;
      top: 24px;
      left: 42px;
      border-radius: 50%;
    }
  }
}
</style>
